export const statusDescriptions: Record<string, Record<string, string>> = {
  job_status: {
    "10": "Complete",
    "survey": "Survey",
    "sold": "Sold",
    "20": "In Progress",
    "40": "Cancel",
    "140": "Incomplete",
    "150": "On Hold",
    "250": "Assigned",
    "260": "Accepted",
  },
  appointment_status: {
    "30": "Initial Appointment Scheduled",
    "70": "On My Way",
    "90": "Arrived",
    "80": "Technician May Be Delayed to Appointment",
    "120": "Missed appointment",
    "200": "Customer Appointment Set",
    "270": "Reschedule Appointment Set",
    "400": "Return Appointment Set",
    "430": "Installation Appointment Set",
    "220": "Appointment Complete",
    "230": "Appointment Cancelled",
    "280": "Left Customer a Message to Schedule",
    "60": "Unable to Contact Customer to Schedule",
  },
  parking_status: {
    parked: "Parked",
    driving: "Driving",
    unparked: "Unparked",
  },
  parts_status: {
    "100": "Parts Ordered",
    "160": "Parts Ordered",
    "380": "Parts Ordered",
    "390": "Equipment Ordered",
    "410": "Parts Have Arrived",
    "420": "Equipment Arrived",
  },
  equipment_status: {
    "390": "Equipment Ordered",
    "420": "Equipment Ordered",
  },
  authorization_status: {
    "290": "Authorization Reported",
    "350": "Authorization Approved",
    "360": "Authorization Denied",
    "370": "Authorization Approved with Limitations",
    "450": "Authorization Awaiting Contractor Input",
    "470": "Draft Autho for Contractor Review",
    "480": "Autho Review with Agent",
  },
  cil_status: {
    "320": "CIL Ordered",
    "330": "CIL Ordered",
    "340": "CIL Ordered",
  },
  invoice_status: {
    "440": "Invoice Ordered",
  },
  cash_status: {
    "500": "Cash Ordered",
  },
  appliance_status: {
    "300": "Appliance Ordered",
    "310": "Appliance Ordered",
  },
  ncc_status: {
    "510": "NCC Accepted",
  },
  quote_status: {
    "530": "Quote Started",
    "540": "Quote Submitted",
    "560": "Quote Ordered",
  },
  drive_status: {
    "70": "On My Way",
    "90": "Arrived",
  },
  complete: {
    "complete": "Complete",
  },
  survey: {
    "survey": "Survey",
  },
  archived: {
    "archived": "Archived",
  },
};

export function getStatusDescription(dispatch: API.Dispatch): string {
  let statusCode = "";
  let statusType = "";

  // Parts/Equipment Ordered force job_status=150 (On Hold) and park the job as
  // a side effect, so neither job_status nor flow_step identifies them. The
  // ordered parts_status is the real user-facing status — label these holds
  // from it until the parts arrive (arrival overwrites parts_status to 410/420).
  const orderedPartsHold =
    dispatch?.dispatch_status?.job_status === "150" &&
    ["100", "160", "380", "390"].includes(dispatch?.dispatch_status?.parts_status ?? "");

  // Terminal job statuses always take priority over flow_step.
  // The observer sets flow_step='appointment' when job_status becomes 40 or 140,
  // so without these early exits those jobs would wrongly show appointment labels.
  // Archived wins over everything: archiving (cron or the office Archive
  // button) writes job_status=150 alongside flow_step=archived, and the
  // terminal-status branch below would otherwise label the job "On Hold".
  if (dispatch?.dispatch_status?.flow_step === "archived") {
    statusCode = "archived";
    statusType = "archived";
  } else if (orderedPartsHold) {
    statusCode = dispatch?.dispatch_status?.parts_status ?? "";
    statusType = "parts_status";
  } else if (["10", "survey", "sold", "40", "140", "150"].includes(dispatch?.dispatch_status?.job_status ?? "")) {
    statusCode = dispatch!.dispatch_status!.job_status ?? "";
    statusType = "job_status";
  } else {
    // Use the flow_step to determine status
    switch (dispatch?.dispatch_status?.flow_step) {
      case "appointment":
        statusCode = dispatch?.dispatch_status?.appointment_status || "";
        statusType = "appointment_status";
        break;
      case "park":
        statusCode = dispatch?.dispatch_status?.parking_status || "";
        statusType = "parking_status";
        break;
      case "parts":
        statusCode = dispatch?.dispatch_status?.parts_status || "";
        statusType = "parts_status";
        break;
      case "equipment":
        statusCode = dispatch?.dispatch_status?.equipment_status || "";
        statusType = "equipment_status";
        break;
      case "contact":
        statusCode = dispatch?.dispatch_status?.contact_status || "";
        statusType = "contact_status";
        break;
      case "authorization":
        statusCode = dispatch?.dispatch_status?.authorization_status || "";
        statusType = "authorization_status";
        break;
      case "cil":
        statusCode = dispatch?.dispatch_status?.cil_status || "";
        statusType = "cil_status";
        break;
      case "invoice":
        statusCode = dispatch?.dispatch_status?.invoice_status || "";
        statusType = "invoice_status";
        break;
      case "cash":
        statusCode = dispatch?.dispatch_status?.cash_status || "";
        statusType = "cash_status";
        break;
      case "appliance":
        statusCode = dispatch?.dispatch_status?.appliance_status || "";
        statusType = "appliance_status";
        break;
      case "ncc":
        statusCode = dispatch?.dispatch_status?.ncc_status || "";
        statusType = "ncc_status";
        break;
      case "quote":
        statusCode = dispatch?.dispatch_status?.quote_status || "";
        statusType = "quote_status";
        break;
      case "drive":
        statusCode = dispatch?.dispatch_status?.drive_status || "";
        statusType = "drive_status";
        break;
      case "complete":
        statusCode = "complete";
        statusType = "complete";
        break;
      case "survey":
        statusCode = "survey";
        statusType = "survey";
        break;
      case "archived":
        statusCode = "archived";
        statusType = "archived";
        break;
      default:
        // Fall back to job_status if no specific flow_step matches
        statusCode = dispatch?.dispatch_status?.job_status || "";
        statusType = "job_status";
    }
  }

  if (!statusCode && statusType && statusType !== "job_status") {
    statusCode = dispatch?.dispatch_status?.job_status || "";
    statusType = "job_status";
  }

  if (statusCode && statusType) {
    const description = statusDescriptions[statusType]?.[statusCode];
    return description || `${statusType}: ${statusCode}`;
  }

  return "Status: Not Set";
}

